"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = exports.alias = void 0;
var _Airplay = _interopRequireDefault(require("./icons/Airplay"));
var _ArrowRight = _interopRequireDefault(require("./icons/ArrowRight"));
var _ArrowLeftCarousel = _interopRequireDefault(require("./icons/ArrowLeftCarousel"));
var _ArrowRightCarousel = _interopRequireDefault(require("./icons/ArrowRightCarousel"));
var _BiggerImage = _interopRequireDefault(require("./icons/BiggerImage"));
var _Calendar = _interopRequireDefault(require("./icons/Calendar"));
var _Cash = _interopRequireDefault(require("./icons/Cash"));
var _Checkmark = _interopRequireDefault(require("./icons/Checkmark"));
var _CheckmarkFilled = _interopRequireDefault(require("./icons/CheckmarkFilled"));
var _ChevronDown = _interopRequireDefault(require("./icons/ChevronDown"));
var _ChevronLeft = _interopRequireDefault(require("./icons/ChevronLeft"));
var _ChevronRight = _interopRequireDefault(require("./icons/ChevronRight"));
var _ChevronUp = _interopRequireDefault(require("./icons/ChevronUp"));
var _Clock = _interopRequireDefault(require("./icons/Clock"));
var _Close = _interopRequireDefault(require("./icons/Close"));
var _CloseCircle = _interopRequireDefault(require("./icons/CloseCircle"));
var _CogWheel = _interopRequireDefault(require("./icons/CogWheel"));
var _Compare = _interopRequireDefault(require("./icons/Compare"));
var _Customers = _interopRequireDefault(require("./icons/Customers"));
var _Dash = _interopRequireDefault(require("./icons/Dash"));
var _Document = _interopRequireDefault(require("./icons/Document"));
var _Doors = _interopRequireDefault(require("./icons/Doors"));
var _ErrorText = _interopRequireDefault(require("./icons/ErrorText"));
var _Error = _interopRequireDefault(require("./icons/Error"));
var _Facebook = _interopRequireDefault(require("./icons/Facebook"));
var _GuidePrice = _interopRequireDefault(require("./icons/GuidePrice"));
var _Heart = _interopRequireDefault(require("./icons/Heart"));
var _HeartFilled = _interopRequireDefault(require("./icons/HeartFilled"));
var _HomeVisit = _interopRequireDefault(require("./icons/HomeVisit"));
var _House = _interopRequireDefault(require("./icons/House"));
var _Inspiration = _interopRequireDefault(require("./icons/Inspiration"));
var _KitchenDetails = _interopRequireDefault(require("./icons/KitchenDetails"));
var _Kitchen = _interopRequireDefault(require("./icons/Kitchen"));
var _KitchenUpgrade = _interopRequireDefault(require("./icons/KitchenUpgrade"));
var _Lock = _interopRequireDefault(require("./icons/Lock"));
var _LogOut = _interopRequireDefault(require("./icons/LogOut"));
var _Measure = _interopRequireDefault(require("./icons/Measure"));
var _Meeting = _interopRequireDefault(require("./icons/Meeting"));
var _Info = _interopRequireDefault(require("./icons/Info"));
var _Order = _interopRequireDefault(require("./icons/Order"));
var _Overview = _interopRequireDefault(require("./icons/Overview"));
var _Pdf = _interopRequireDefault(require("./icons/Pdf"));
var _Pen = _interopRequireDefault(require("./icons/Pen"));
var _Phone = _interopRequireDefault(require("./icons/Phone"));
var _Photo = _interopRequireDefault(require("./icons/Photo"));
var _PlanAndDesign = _interopRequireDefault(require("./icons/PlanAndDesign"));
var _Plus = _interopRequireDefault(require("./icons/Plus"));
var _Products = _interopRequireDefault(require("./icons/Products"));
var _Qdp = _interopRequireDefault(require("./icons/Qdp"));
var _QuestionMark = _interopRequireDefault(require("./icons/QuestionMark"));
var _Quiz = _interopRequireDefault(require("./icons/Quiz"));
var _Quote = _interopRequireDefault(require("./icons/Quote"));
var _Scrapbook = _interopRequireDefault(require("./icons/Scrapbook"));
var _Search = _interopRequireDefault(require("./icons/Search"));
var _Store = _interopRequireDefault(require("./icons/Store"));
var _StoreMeeting = _interopRequireDefault(require("./icons/StoreMeeting"));
var _ToolsMenu = _interopRequireDefault(require("./icons/ToolsMenu"));
var _Upload = _interopRequireDefault(require("./icons/Upload"));
var _User = _interopRequireDefault(require("./icons/User"));
var _VirtualPlanner = _interopRequireDefault(require("./icons/VirtualPlanner"));
var _DotFilled = _interopRequireDefault(require("./icons/DotFilled"));
var _Download = _interopRequireDefault(require("./icons/Download"));
var _VideoMeeting = _interopRequireDefault(require("./icons/VideoMeeting"));
var _QuoteAlternate = _interopRequireDefault(require("./icons/QuoteAlternate"));
var _MeetingAlternate = _interopRequireDefault(require("./icons/MeetingAlternate"));
var _Showroom = _interopRequireDefault(require("./icons/Showroom"));
var _Location = _interopRequireDefault(require("./icons/Location"));
var _Trash = _interopRequireDefault(require("./icons/Trash"));
var _Eye = _interopRequireDefault(require("./icons/Eye"));
var _EyeDisabled = _interopRequireDefault(require("./icons/EyeDisabled"));
var _ArrowLeftDisabled = _interopRequireDefault(require("./icons/ArrowLeftDisabled"));
var _ArrowRightDisabled = _interopRequireDefault(require("./icons/ArrowRightDisabled"));
var icons = {
  airplay: _Airplay.default,
  'arrow-right': _ArrowRight.default,
  'arrow-right-carousel': _ArrowRightCarousel.default,
  'arrow-left-disabled': _ArrowLeftDisabled.default,
  'arrow-right-disabled': _ArrowRightDisabled.default,
  'arrow-left-carousel': _ArrowLeftCarousel.default,
  'bigger-image': _BiggerImage.default,
  calendar: _Calendar.default,
  cash: _Cash.default,
  checkmark: _Checkmark.default,
  'checkmark-filled': _CheckmarkFilled.default,
  'chevron-down': _ChevronDown.default,
  'chevron-left': _ChevronLeft.default,
  'chevron-right': _ChevronRight.default,
  'chevron-up': _ChevronUp.default,
  clock: _Clock.default,
  close: _Close.default,
  'close-circle': _CloseCircle.default,
  'cog-wheel': _CogWheel.default,
  'dash': _Dash.default,
  document: _Document.default,
  doors: _Doors.default,
  'dot-filled': _DotFilled.default,
  download: _Download.default,
  'error-text': _ErrorText.default,
  error: _Error.default,
  information: _Info.default,
  facebook: _Facebook.default,
  'guide-price': _GuidePrice.default,
  heart: _Heart.default,
  'home-visit': _HomeVisit.default,
  house: _House.default,
  'heart-filled': _HeartFilled.default,
  inspiration: _Inspiration.default,
  'kitchen-details': _KitchenDetails.default,
  'store-upgrade-meeting': _KitchenUpgrade.default,
  kitchen: _Kitchen.default,
  lock: _Lock.default,
  'log-out': _LogOut.default,
  measure: _Measure.default,
  meeting: _Meeting.default,
  order: _Order.default,
  overview: _Overview.default,
  pen: _Pen.default,
  phone: _Phone.default,
  photo: _Photo.default,
  'plan-and-design': _PlanAndDesign.default,
  plus: _Plus.default,
  products: _Products.default,
  qdp: _Qdp.default,
  'question-mark': _QuestionMark.default,
  quiz: _Quiz.default,
  quote: _Quote.default,
  scrapbook: _Scrapbook.default,
  search: _Search.default,
  store: _Store.default,
  'store-meeting': _StoreMeeting.default,
  'tools-menu': _ToolsMenu.default,
  upload: _Upload.default,
  user: _User.default,
  'virtual-planner': _VirtualPlanner.default,
  'video-meeting': _VideoMeeting.default,
  compare: _Compare.default,
  pdf: _Pdf.default,
  'quote-alternate': _QuoteAlternate.default,
  'meeting-alternate': _MeetingAlternate.default,
  showroom: _Showroom.default,
  location: _Location.default,
  customers: _Customers.default,
  trash: _Trash.default,
  eye: _Eye.default,
  'eye-disabled': _EyeDisabled.default
};

// ALIAS
var alias = exports.alias = {
  bada: 'meeting',
  check: 'checkmark',
  dash: 'dash',
  plus: 'plus',
  account: 'checkmark',
  onboarding: 'user',
  info: 'kitchen-details',
  'kitchen-information': 'kitchen-details',
  measurements: 'measure',
  'kitchen-measurements': 'measure',
  threed: 'qdp',
  'kitchen-drawings': 'qdp',
  favorite: 'heart',
  'favorite-products': 'heart',
  configuration: 'cog-wheel',
  'kitchen-configurations': 'cog-wheel',
  caretRight: 'chevron-right',
  linkArrowRight: 'arrow-right',
  CarouselArrowRight: 'arrow-right-carousel',
  CarouselArrowLeft: 'arrow-left-carousel',
  DisabledArrowRight: 'arrow-right-disabled',
  DisabledArrowLeft: 'arrow-left-disabled',
  design: 'plan-and-design',
  'error-icon': 'error'
};
var _default = exports.default = icons;